import { Sparkles, type LucideIcon } from "lucide-react";

import { activeNavId } from "./navItems";

export interface TopBarContextAction {
  id: string;
  label: string;
  icon: LucideIcon;
  path: string;
  highlight?: boolean;
}

export interface TopBarPageContext {
  id: string;
  /** Short label under the Twido logo. */
  subtitle: string;
  /** Contextual icons injected into the actions pill (excluding global controls). */
  actions: TopBarContextAction[];
}

const PAGE_CONTEXT: Record<string, Omit<TopBarPageContext, "id">> = {
  kai: {
    subtitle: "Kai",
    actions: [],
  },
  preferences: {
    subtitle: "Preferences",
    actions: [],
  },
  dashboard: {
    subtitle: "Your workspace",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  bookings: {
    subtitle: "Bookings",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  rates: {
    subtitle: "Rates",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  schedule: {
    subtitle: "Schedule",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  reports: {
    subtitle: "Reports",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  feed: {
    subtitle: "Activity",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
  admin: {
    subtitle: "Admin",
    actions: [
      {
        id: "kai",
        label: "Ask Kai",
        icon: Sparkles,
        path: "/",
        highlight: true,
      },
    ],
  },
};

const DEFAULT_CONTEXT = {
  subtitle: "Bookings",
  actions: [
    {
      id: "kai",
      label: "Ask Kai",
      icon: Sparkles,
      path: "/",
      highlight: true,
    },
  ],
};

export function getTopBarPageContext(pathname: string): TopBarPageContext {
  if (pathname === "/preferences") {
    return { id: "preferences", ...PAGE_CONTEXT.preferences };
  }

  const bookingDetailMatch = pathname.match(/^\/bookings\/([^/]+)$/);
  if (bookingDetailMatch) {
    const sourceId = decodeURIComponent(bookingDetailMatch[1]);
    return {
      id: "bookings",
      subtitle: sourceId,
      actions: [
        {
          id: "kai",
          label: "Ask Kai",
          icon: Sparkles,
          path: "/",
          highlight: true,
        },
      ],
    };
  }

  const rateDetailMatch = pathname.match(/^\/rates\/([^/]+)$/);
  if (rateDetailMatch) {
    return {
      id: "rates",
      subtitle: "Rates",
      actions: [
        {
          id: "kai",
          label: "Ask Kai",
          icon: Sparkles,
          path: "/",
          highlight: true,
        },
      ],
    };
  }

  const reportDetailMatch = pathname.match(/^\/reports\/([^/]+)$/);
  if (reportDetailMatch) {
    return {
      id: "reports",
      subtitle: "Reports",
      actions: [
        {
          id: "kai",
          label: "Ask Kai",
          icon: Sparkles,
          path: "/",
          highlight: true,
        },
      ],
    };
  }

  const id = activeNavId(pathname);
  const ctx = PAGE_CONTEXT[id] ?? DEFAULT_CONTEXT;
  return { id, ...ctx };
}
